import { zeroPad, dateToString } from '@/shared/lib';
import _ from 'lodash';
import { t } from 'ttag';

interface TitleInfo {
  studyFid?: string | number;
  patientName?: string;
  interprettingPhysicianName?: string;
  startStudyDate?: string;
  eventTime?: string;
  timezone?: string;
  studyTimeOffset?: number;
  facilityCountry?: string;
  facilityTimezone?: string;
}

interface TitleBlock {
  title: string;
  content: string;
}

/**
 * Builds the labeled title blocks - study id, patient, physician and event time - shown above an inbox ECG strip, or an empty array when no title info is supplied. Zero-pads the study id and formats the event time against the study's timezone, offset and facility.
 *
 * @param titleInfo - The event title info carrying study, patient, physician and timezone fields.
 * @returns The title and content pairs for the header, empty when there is no info.
 */
const generateTitleBlockArray = (titleInfo: TitleInfo | undefined): TitleBlock[] =>
  titleInfo && !_.isEmpty(titleInfo)
    ? [
        {
          title: t`Study ID`,
          content: zeroPad(titleInfo.studyFid),
        },
        {
          title: t`Patient`,
          content: titleInfo.patientName,
        },
        {
          title: t`Physician`,
          content: titleInfo.interprettingPhysicianName,
        },
        {
          title: t`Event time`,
          content: dateToString({
            startStudyDate: titleInfo.startStudyDate,
            isoDate: titleInfo.eventTime,
            timezone: titleInfo.timezone,
            studyTimeOffset: titleInfo.studyTimeOffset,
            facilityCountry: titleInfo.facilityCountry,
            facilityTimezone: titleInfo.facilityTimezone,
          }),
        },
      ]
    : [];

export { generateTitleBlockArray };
